// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Autoplay, Pagination } from "swiper/modules";
import PostApiCall from "../../Helper/PostApi";
import { Skeleton } from "antd";
import Birthday from "../../assets/img/category-img/BIRTHDAYS.png";
import Wedding from "../../assets/img/category-img/wedding.png";
import Anniversary from "../../assets/img/category-img/anniversary.png";
import Flowers from "../../assets/img/category-img/flowers.png";
import FlowersArrangements from "../../assets/img/category-img/flower arrangements.png";
import Combos from "../../assets/img/category-img/combos.png";
import Chocolates from "../../assets/img/category-img/chocolates.png";
import Cake from "../../assets/img/category-img/cakes.png";
export default function OccasionSection() {
  const [vertical, setVertical] = useState([]);
  useEffect(() => {
    GetProductVertical();
  }, []);
  const GetProductVertical = () => {
    PostApiCall.postRequest(
      {
        catCount: "*",
      },
      "GetProductVertical"
    ).then((results) =>
      results.json().then((obj1) => {
        if (results.status === 200 || results.status === 201) {
          setVertical(
            obj1.data.filter((vertical) => vertical.fld_status === "Active")
          );
        }
      })
    );
  };
  return (
    <section className="py-4 section-spacing-x">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 mx-auto text-center main-heading-box">
            <h2 className="main-heading">Gifts for Every Occasion</h2>
            <p>Express Your Feelings with Flowers, Chocolates and More...</p>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <Swiper
              pagination={{
                dynamicBullets: true,
                clickable: true,
              }}
              // autoplay="flase"
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              slidesPerView={2}
              spaceBetween={10}
              breakpoints={{
                640: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 6,
                  spaceBetween: 10,
                },
                1024: {
                  slidesPerView: 8,
                  spaceBetween: 10,
                },
              }}
              modules={[Autoplay, Pagination]}
              className="mySwiper pb-4 category-section">
              {/* {vertical.length > 0 ? (
                vertical?.map((data, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <Link
                        to={`/pct/${data.fld_route.toLowerCase()}-${data.selected_cat_name?.replace(/\s/g, "-").replace('/', '').toLowerCase()}`}
                      // to={`/ct/${data.selected_cat_name
                      //   ?.toLowerCase()
                      //   ?.replace(/\s/g, "-")
                      //   .replace("/", "-")}/${data.fld_verticleid}/${data.selected_cat_id
                      //   }`}
                      >
                        <img
                          alt={data.selected_cat_name}
                          src={data.fld_verticalImage}
                          className="img-fluid"
                        />
                      </Link>
                    </SwiperSlide>
                  );
                })
              ) : (
                <>
                  <SwiperSlide>
                    <Skeleton.Image
                      alt="Category"
                      className="img-fluid w-100 h-100"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Skeleton.Image
                      alt="Category"
                      className="img-fluid w-100 h-100"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Skeleton.Image
                      alt="Category"
                      className="img-fluid w-100 h-100"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Skeleton.Image
                      alt="Category"
                      className="img-fluid w-100 h-100"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Skeleton.Image
                      alt="Category"
                      className="img-fluid w-100 h-100"
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Skeleton.Image
                      alt="Category"
                      className="img-fluid w-100 h-100"
                    />
                  </SwiperSlide>
                </>
              )} */}

              <SwiperSlide>
                <Link to="/category/birthday">
                  <img alt="Birthday" src={Birthday} className="img-fluid" />
                </Link>
                <Link to="/category/birthday">Birthday</Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link to="/category/wedding">
                  <img alt="Weddings" src={Wedding} className="img-fluid" />
                </Link>
                <Link to="/category/wedding">Weddings</Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link to="/category/anniversary">
                  <img
                    alt="Anniversary"
                    src={Anniversary}
                    className="img-fluid"
                  />
                </Link>
                <Link to="/category/anniversary">Anniversary</Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link to="/category/flowers">
                  <img alt="Flowers" src={Flowers} className="img-fluid" />
                </Link>
                <Link to="/category/flowers">Flowers</Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link to="/category/flower-arrangement">
                  <img alt="Flower Arrangements" src={FlowersArrangements} className="img-fluid" />
                </Link>
                <Link to="/category/flower-arrangement">Flower Arrangements</Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link to="/category/cakes">
                  <img alt="Cakes" src={Cake} className="img-fluid" />
                </Link>
                <Link to="/category/cakes">Cakes</Link>
              </SwiperSlide>
              <SwiperSlide>
                <Link to="/category/chocolate">
                  <img alt="Chocolate" src={Chocolates} className="img-fluid" />
                </Link>
                <Link to="/category/chocolate">Chocolate</Link>
              </SwiperSlide>

              <SwiperSlide>
                <Link to="/category/combos">
                  <img alt="Combos" src={Combos} className="img-fluid" />
                </Link>
                <Link to="/category/combos">Combos</Link>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
}
